/* Adapt Dew — scroll-pin gallery mechanism + unified pill nav. */
console.log('[adapt-scrollpin] script file loaded');
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  /* ---------- main image rotation (2 images: dots + arrows + swipe) ---------- */
  function setupMainRotation() {
    var box = document.querySelector('[data-scrollpin-main]');
    if (!box) return;
    var slides = box.querySelectorAll('.ad-scrollpin-mainSlide');
    var dotsWrap = box.querySelector('[data-scrollpin-dots]');
    var prevBtn = box.querySelector('[data-scrollpin-prev]');
    var nextBtn = box.querySelector('[data-scrollpin-next]');
    if (slides.length < 2) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }

    var current = 0;
    var dots = [];
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'is-' + (i === 0 ? 'on' : 'off');
      if (i === 0) b.classList.add('is-on');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });

    function goTo(index) {
      index = ((index % slides.length) + slides.length) % slides.length;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === index); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    var startX = null, dragging = false;
    function onStart(x) { startX = x; dragging = true; }
    function onEnd(x) {
      if (!dragging || startX === null) return;
      var delta = x - startX;
      if (Math.abs(delta) > 40) { delta < 0 ? goTo(current + 1) : goTo(current - 1); }
      dragging = false; startX = null;
    }
    box.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    box.addEventListener('touchend', function (e) { onEnd(e.changedTouches[0].clientX); });
    box.addEventListener('mousedown', function (e) { onStart(e.clientX); e.preventDefault(); });
    window.addEventListener('mouseup', function (e) { if (dragging) onEnd(e.clientX); });
  }

  /* ---------- scroll-pin mechanism (phase1/phase2/wait, symmetric) ---------- */
  var recalcRefs = null;

  function recalc() {
    if (!isDesktop() || !recalcRefs) return;
    var r = recalcRefs;

    var imageOneRect = r.imageOne.getBoundingClientRect();
    var imageThreeRect = r.imageThree.getBoundingClientRect();
    var lastWrapperRect = r.lastWrapper.getBoundingClientRect();

    var releasePoint = (imageThreeRect.top - imageOneRect.top) + (imageThreeRect.height / 2);
    var imagesBaseHeight = lastWrapperRect.top - imageOneRect.top;
    var lastImageHeight = r.lastImageBox.offsetHeight;
    var imagesNaturalTotal = imagesBaseHeight + lastImageHeight;

    var infoBoxHeight = r.infoBox.offsetHeight;
    var infoRequiredTotal = releasePoint + infoBoxHeight;
    r.infoPhase1.style.height = infoRequiredTotal + 'px';

    var sharedTotal = Math.max(imagesNaturalTotal, infoRequiredTotal);

    var tailHeight = Math.max(0, sharedTotal - infoRequiredTotal);
    r.infoTail.style.height = tailHeight + 'px';

    var waitAmount = Math.max(0, sharedTotal - imagesNaturalTotal);
    r.lastWrapper.style.height = (lastImageHeight + waitAmount) + 'px';

    r.sharedTotal = sharedTotal;
  }

  function setupScrollPin() {
    var imageOne = document.querySelector('[data-scrollpin-image-one]');
    var imageThree = document.querySelector('[data-scrollpin-image-three]');
    var lastWrapper = document.querySelector('[data-scrollpin-last-wrapper]');
    var lastImageBox = lastWrapper ? lastWrapper.querySelector('.ad-scrollpin-smallBox') : null;
    var infoPhase1 = document.querySelector('[data-scrollpin-info-phase1]');
    var infoBox = document.querySelector('.ad-scrollpin-infoBox');
    var infoTail = document.querySelector('[data-scrollpin-info-tail]');

    if (!imageOne || !imageThree || !lastWrapper || !lastImageBox || !infoPhase1 || !infoBox || !infoTail) return;

    recalcRefs = { imageOne: imageOne, imageThree: imageThree, lastWrapper: lastWrapper,
                   lastImageBox: lastImageBox, infoPhase1: infoPhase1, infoBox: infoBox, infoTail: infoTail };

    recalc();
    window.addEventListener('resize', recalc);
    document.querySelectorAll('.ad-pdp__acc, .ad-mini__item').forEach(function (d) {
      d.addEventListener('toggle', recalc);
    });
  }

  /* ---------- pill nav: native anchor links + floating twin + active-highlight,
     unified across all breakpoints ---------- */
  function setupPillNav() {
    var staticNav = document.querySelector('[data-scrollpin-pill]');
    if (!staticNav) { console.log('[adapt-scrollpin] pill nav: static nav not found'); return; }

    var floatingWrap = document.createElement('div');
    floatingWrap.className = 'ad-scrollpin-floatingWrap';
    floatingWrap.appendChild(staticNav.cloneNode(true));
    document.body.appendChild(floatingWrap);
    var floatingNav = floatingWrap.querySelector('[data-scrollpin-pill]');

    var staticLinks = Array.prototype.slice.call(staticNav.querySelectorAll('a[data-nav-item]'));
    var floatingLinks = Array.prototype.slice.call(floatingNav.querySelectorAll('a[data-nav-item]'));

    function setActive(key) {
      staticLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
      floatingLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-nav-item') === key); });
    }

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var fullyPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          floatingWrap.classList.toggle('is-visible', fullyPassed);
        });
      }, { threshold: 0 });
      visibilityObserver.observe(staticNav);
    } else {
      console.log('[adapt-scrollpin] pill nav: IntersectionObserver not supported, floating twin disabled');
    }

    var sections = {
      testimonials: document.getElementById('pdp-anchor-testimonials'),
      benefits: document.getElementById('pdp-anchor-benefits'),
      faq: document.getElementById('pdp-anchor-faq')
    };
    if (!sections.testimonials || !sections.benefits || !sections.faq) {
      console.log('[adapt-scrollpin] pill nav: one or more anchor sections not found', sections);
    }
    if ('IntersectionObserver' in window) {
      var activeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActive(entry.target.id.replace('pdp-anchor-', ''));
          }
        });
      }, { rootMargin: '-110px 0px -70% 0px', threshold: 0 });

      Object.keys(sections).forEach(function (key) {
        if (sections[key]) activeObserver.observe(sections[key]);
      });
    }

    setActive('testimonials');
    console.log('[adapt-scrollpin] pill nav: setup complete');
  }

  /* ---------- swatch-click → vertical gallery scroll (progressive enhancement) ---------- */
  function setupSwatchGalleryScroll() {
    document.querySelectorAll('.ad-bnd [data-sw]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mediaId = btn.getAttribute('data-media-id');
        if (!mediaId) return;
        var target = document.querySelector('.ad-scrollpin-smallCol [data-media-id="' + mediaId + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ---------- legacy gallery: single-row swipeable track + dots (mobile/tablet) ---------- */
  function setupLegacyGallery() {
    document.querySelectorAll('[data-legacy-gallery]').forEach(function (mw) {
      var t = mw.querySelector('[data-legacy-track]');
      var dots = mw.querySelector('[data-legacy-dots]');
      if (!t) return;
      var slides = t.children;
      if (!slides.length || slides.length < 2) { if (dots) dots.style.display = 'none'; return; }

      for (var i = 0; i < slides.length; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.className = 'ad-dot' + (idx === 0 ? ' is-on' : '');
          b.setAttribute('aria-label', 'Image ' + (idx + 1));
          b.addEventListener('click', function () {
            t.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(b);
        })(i);
      }

      var tick = false;
      t.addEventListener('scroll', function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () {
          var idx = Math.min(slides.length - 1, Math.max(0, Math.round(t.scrollLeft / slides[0].offsetWidth)));
          for (var j = 0; j < dots.children.length; j++) { dots.children[j].classList.toggle('is-on', j === idx); }
          tick = false;
        });
      }, { passive: true });
    });
  }

  /* ---------- zoom: legacy gallery zoom button opens the CURRENT slide full-screen.
     Button existed in markup with no handler before this fix — tracks scroll position
     of the legacy track the same way the dots do, so it always zooms the image actually
     in view rather than always the first slide. ---------- */
  var zoomStylesInjected = false;
  function injectZoomStyles() {
    if (zoomStylesInjected) return;
    zoomStylesInjected = true;
    var style = document.createElement('style');
    style.textContent =
      '.ad-zoom-overlay{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.92);' +
      'display:flex;align-items:center;justify-content:center;padding:24px;' +
      'opacity:0;transition:opacity .18s ease;}' +
      '.ad-zoom-overlay.is-on{opacity:1;}' +
      '.ad-zoom-overlay img{max-width:100%;max-height:100%;object-fit:contain;' +
      'border-radius:4px;touch-action:pinch-zoom;}' +
      '.ad-zoom-close{position:absolute;top:16px;right:16px;width:40px;height:40px;' +
      'border-radius:50%;border:none;background:rgba(255,255,255,.12);color:#fff;' +
      'font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;' +
      'justify-content:center;}' +
      '.ad-zoom-close:hover{background:rgba(255,255,255,.22);}';
    document.head.appendChild(style);
  }

  function openZoomOverlay(src, alt) {
    injectZoomStyles();
    var overlay = document.createElement('div');
    overlay.className = 'ad-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ad-zoom-close';
    closeBtn.setAttribute('aria-label', 'Close zoomed image');
    closeBtn.innerHTML = '&times;';

    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';

    overlay.appendChild(closeBtn);
    overlay.appendChild(img);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-on'); });

    function close() {
      document.body.style.overflow = '';
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === closeBtn) close();
    });
    document.addEventListener('keydown', onKey);
  }

  function setupZoom() {
    document.querySelectorAll('[data-legacy-gallery]').forEach(function (mw) {
      var zoomBtn = mw.querySelector('.ad-feat__zoom');
      var track = mw.querySelector('[data-legacy-track]');
      if (!zoomBtn || !track) return;
      zoomBtn.addEventListener('click', function () {
        var slides = track.children;
        if (!slides.length) return;
        var slideWidth = slides[0].offsetWidth || 1;
        var idx = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / slideWidth)));
        var activeImg = slides[idx] ? slides[idx].querySelector('img') : null;
        if (!activeImg) return;
        openZoomOverlay(activeImg.currentSrc || activeImg.src, activeImg.alt);
      });
    });

    /* desktop: main scroll-pin image — both the visible magnifier button (added
       2026-08-10, previously had NO icon at all, just a bare cursor style with
       zero visual hint it was clickable) and a direct click on the image itself
       open the currently-active slide. */
    var mainBox = document.querySelector('[data-scrollpin-main]');
    if (mainBox) {
      function zoomActiveMainSlide() {
        var activeSlide = mainBox.querySelector('.ad-scrollpin-mainSlide.is-on') || mainBox.querySelector('.ad-scrollpin-mainSlide');
        var img = activeSlide ? activeSlide.querySelector('img') : null;
        if (!img) return;
        openZoomOverlay(img.currentSrc || img.src, img.alt);
      }
      var zoomBtn = mainBox.querySelector('[data-scrollpin-zoom]');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          zoomActiveMainSlide();
        });
      }
      mainBox.querySelectorAll('.ad-scrollpin-mainSlide img').forEach(function (img) {
        img.addEventListener('click', zoomActiveMainSlide);
      });
    }

    /* desktop: the 6 small thumbnail images are also zoomable on click —
       previously had zero zoom behavior at all. */
    document.querySelectorAll('.ad-scrollpin-smallBox').forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) return;
      box.addEventListener('click', function () {
        openZoomOverlay(img.currentSrc || img.src, img.alt);
      });
    });
  }

  /* ---------- suppress floating pill while any overlay (menu drawer, cart drawer,
     search modal) is open — it was only reacting to scroll position, with no idea
     an overlay had opened on top of it, so it kept floating visibly over the menu ---------- */
  function setupFloatingPillSuppression() {
    function isAnyOverlayOpen() {
      return !!document.querySelector(
        'details[open][id*="menu-drawer" i], ' +
        'details[open][id*="drawer" i], ' +
        'theme-drawer[open], ' +
        'dialog[open], ' +
        '[data-search-modal][open], ' +
        '.search-modal.is-open, ' +
        '.menu-drawer.is-open'
      );
    }
    function refresh() {
      var wraps = document.querySelectorAll('.ad-scrollpin-floatingWrap');
      var suppress = isAnyOverlayOpen();
      wraps.forEach(function (w) { w.classList.toggle('is-suppressed', suppress); });
    }
    document.addEventListener('toggle', refresh, true);
    document.addEventListener('click', function () { setTimeout(refresh, 50); }, true);
    if ('MutationObserver' in window) {
      new MutationObserver(refresh).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true
      });
    }
    refresh();
  }

  function init() {
    console.log('[adapt-scrollpin] init() called, isDesktop =', isDesktop());
    if (isDesktop()) {
      try { setupMainRotation(); } catch (e) { console.error('adapt-scrollpin: main rotation setup failed', e); }
      try { setupScrollPin(); } catch (e) { console.error('adapt-scrollpin: scroll-pin setup failed', e); }
    } else {
      try { setupLegacyGallery(); } catch (e) { console.error('adapt-scrollpin: legacy gallery setup failed', e); }
    }
    try { setupPillNav(); } catch (e) { console.error('adapt-scrollpin: pill nav setup failed', e); }
    try { setupSwatchGalleryScroll(); } catch (e) { console.error('adapt-scrollpin: swatch scroll setup failed', e); }
    try { setupZoom(); } catch (e) { console.error('adapt-scrollpin: zoom setup failed', e); }
    try { setupFloatingPillSuppression(); } catch (e) { console.error('adapt-scrollpin: floating pill suppression setup failed', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', function () {
    recalc();
  });
})();
